import { UserManualDialogChaptersKeys } from '../../../../state/dialogs/chapters';
import { getOpenChapter } from '../../../../state/dialogs/useUserManualDialog';
import { useAppSelector } from '../../../../state/hooks';
import { ReactNode, useEffect } from 'react';
import { GetStartedWelcomeChapter } from './GetStartedWelcomeChapter';
import { GetStartedGuideChapter } from './GetStartedGuideChapter';
import { GetStartedOverviewChapter } from './GetStartedOverviewChapter';
import { DashboardDashboardFunctionsChapter } from './DashboardDashboardFunctionsChapter';
import { BookingsBookingOverviewChapter } from './BookingsBookingOverviewChapter';
import {
  CardManagementVehicleOverviewChapter,
  CardManagementAddingCardsChapter,
  CardManagementActivatingServicesChapter,
} from './CardManagementChapters';
import { TransactionsListChapter } from './TransactionsListChapter';
import { ServicesFuellingChapter } from './ServicesFuellingChapter';
import { ServicesMobileFuellingChapter } from './ServicesMobileFuellingChapter';
import { ServicesParkingChapter } from './ServicesParkingChapter';
import { ServicesWashingChapter } from './ServicesWashingChapter';
import { ServicesRepairAndMaintenanceChapter } from './ServicesRepairAndMaintenanceChapter';
import { ServicesChargingChapter } from './ServicesChargingChapter';

const chapters: { [key in UserManualDialogChaptersKeys]: ReactNode } = {
  getStartedWelcome: <GetStartedWelcomeChapter />,
  getStartedGuide: <GetStartedGuideChapter />,
  getStartedOverview: <GetStartedOverviewChapter />,
  dashboardDashboardFunctions: <DashboardDashboardFunctionsChapter />,
  bookingsBookingOverview: <BookingsBookingOverviewChapter />,
  servicesFuelling: <ServicesFuellingChapter />,
  servicesMobileFuelling: <ServicesMobileFuellingChapter />,
  servicesParking: <ServicesParkingChapter />,
  servicesWashing: <ServicesWashingChapter />,
  servicesRepairAndMaintenance: <ServicesRepairAndMaintenanceChapter />,
  servicesCharging: <ServicesChargingChapter />,
  vehicleOverview: <CardManagementVehicleOverviewChapter />,
  addingServiceCards: <CardManagementAddingCardsChapter />,
  activatingServices: <CardManagementActivatingServicesChapter />,
  transactionsList: <TransactionsListChapter />,
};

export const Chapters = () => {
  const currentChapter = useAppSelector(getOpenChapter);

  if (currentChapter === undefined) {
    return <></>;
  }

  useEffect(() => {
    const modal = document.querySelector('.modal-body');
    if (modal) {
      modal.scrollTop = 0;
    }
  }, [currentChapter]);

  return chapters[currentChapter];
};
